"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NoopRating = /** @class */ (function () {
    function NoopRating(message) {
        this.spec = message;
    }
    NoopRating.prototype.render = function (renderer, isNested) {
        var div = document.createElement("div");
        div.classList.add("lto-rating-container");
        var elements = (this.spec.elements || []).map(function (e) { return renderer.render(e); });
        elements.forEach(function (e) { return e.forEach(function (x) { return div.appendChild(x); }); });
        return div;
    };
    return NoopRating;
}());
exports.NoopRating = NoopRating;
